export default __webpack_public_path__ + "static/media/IBimagepositiverunningmidstance1.69cd0cae.png";